/** Shared carousel admin UI styles */
export const carouselGradientBtn = {
  textTransform: "none",
  background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
  fontFamily: "inherit",
  whiteSpace: "nowrap",
  "&:hover": {
    background: "linear-gradient(90deg, #5f1fc4 0%, #8a32c4 76.93%)",
  },
};

export const carouselSectionCard = {
  width: "100%",
  background: "#fff",
  borderRadius: "16px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  border: "1px solid #ece6f8",
  overflow: "hidden",
};

export const carouselSectionHeader = {
  px: { xs: 2, sm: 3 },
  py: 2,
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  alignItems: { xs: "stretch", sm: "center" },
  justifyContent: "space-between",
  gap: 2,
  borderBottom: "1px solid #ece6f8",
  background: "linear-gradient(180deg, #faf8ff 0%, #fff 100%)",
};

export const carouselOutlinedCard = {
  borderRadius: 2,
  borderColor: "#e6e0f5",
};
